import { render, staticRenderFns } from "./AdminParameters.vue?vue&type=template&id=3eec05ac&scoped=true&"
import script from "./AdminParameters.vue?vue&type=script&lang=js&"
export * from "./AdminParameters.vue?vue&type=script&lang=js&"
import style0 from "./AdminParameters.vue?vue&type=style&index=0&id=3eec05ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eec05ac",
  null
  
)

export default component.exports